import React from 'react';
import { Box, BoxProps } from 'pounceV2';

import VirtualizedMenuItemsV3 from './VirtualizedMenuItems/VirtualizedMenuItemsV3';
import StaticMenuItemsV3 from './StaticMenuItemsV3';

export type RenderItemProps<T> = {
  item: T;
  isNested?: boolean;
  style?: any;
};

export interface SharedMenuItemsProps<T> {
  items: T[];
  renderItem: (renderItemProps: RenderItemProps<T>) => React.ReactNode;
  itemToGroup: (item: T) => string;
}

interface MenuItemsProps<T> extends SharedMenuItemsProps<T> {
  shouldVirtualize?: boolean;
}

/**
 * Acts as a wrapper of MenuItems in a list of dropdown options,
 * to allow grouping.
 */
function MenuItemsV3<Item>({
  shouldVirtualize,
  ...props
}: MenuItemsProps<Item>): React.ReactElement<MenuItemsProps<Item>> | React.ReactElement<BoxProps> {
  return shouldVirtualize ? (
    <VirtualizedMenuItemsV3 {...props} />
  ) : (
    <Box
      as="ul"
      sx={{
        maxHeight: 500,
        overflowY: 'auto',
        listStyle: 'none',
      }}
    >
      <StaticMenuItemsV3 {...props} />
    </Box>
  );
}

export default MenuItemsV3;
